import {ChartType} from 'common/types/reports/bookmark';
import {FiltersOperator} from 'common/query-builder/query-entry-section/types';

import {BookmarkYAxisOptions, FilterDeterminer} from './types';

export const OTHER_SEGMENT_VALUE = `$other_segment`;

export const ChartResultChartTypes = [
  ChartType.Line,
  ChartType.StackedLine,
  ChartType.Bar,
  ChartType.StackedBar,
  ChartType.Pie,
  ChartType.Table,
  ChartType.Metric,
];

export const FILTER_DETERMINER_ALL: FilterDeterminer = `all`;
export const FILTER_DETERMINER_ANY: FilterDeterminer = `any`;

export const DETERMINER_MAPPING = {
  [FiltersOperator.And]: FILTER_DETERMINER_ALL,
  [FiltersOperator.Or]: FILTER_DETERMINER_ANY,
};

export const EMPTY_BOOKMARK_NAME = `Untitled Insights Report`;

export enum QueryMode {
  Events = `Events`,
  Groups = `Profiles`,
  Funnels = `Funnels`,
  Retention = `Retention`,
}

// NOTE: This can't just be an empty object because the way we call Lodash.mergeWith
// it will overwrite existing values with `undefined` if each value is explicitly
// `undefined`.
export const EMPTY_BOOKMARK_Y_AXIS_OPTIONS: BookmarkYAxisOptions = {
  axisUnit: undefined,
  labels: undefined,
  min: undefined,
  max: undefined,
  title: undefined,
  type: undefined,
  useSoftMinMax: undefined,
};

export const INSIGHTS_METRICS_LIMIT_OVERRIDES = {
  2462203: 80, // TODO: Remove after 2/1/26
  2785969: 80, // TODO: Remove after 2/1/26
  3251788: 70, // TODO: Remove after 2/1/26
  3735912: 70, // TODO: Remove after 2/1/26
  2852652: 100, // TODO: Remove after 2/1/26
  2852656: 100, // TODO: Remove after 2/1/26
  2852669: 100, // TODO: Remove after 2/1/26
  2852677: 100, // TODO: Remove after 2/1/26
  2969143: 100, // TODO: Remove after 2/1/26
  3300345: 100, // TODO: Remove after 2/1/26
  3542920: 100, // TODO: Remove after 2/1/26
  2354103: 40, // TODO: Remove after 3/1/26
  1952195: 130, // TODO: Remove after 5/1/26
};
